import {inject} from 'aurelia-framework';  
import {Router} from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import { SmtpSettingAPI } from '../../services/admin/smtpSettingAPI';

@inject(AuthService, Router, SmtpSettingAPI, UserMessageService)
export class SiteParameters {
    constructor(authService, router, api, userMessageService) {
        
        this.authService = authService;
        this.router = router;
        this.api = api;
        this.userMessageService = userMessageService;

        this.account_id = "";
        this.whitelabel_id = "";
        this.user_name = "";
        this.user_pass = "";
        this.server_port = "";
        this.server_name = "";
        this.from_name = "";
        this.from_email = "";
        this.reply_to_address = "";
        this.smtp_status = false;


        this.saving = false;
    }

    activate(params) {
        this.loading = true;

        this.userInfo = this.authService.getUser();
        this.data = {
            "account_id": this.userInfo.id,
            "whitelabel_id": this.userInfo.whitelabel_id || null
        }

        this.load();        
    }

    load() {
        this.api.getSMTPSettings(
            this.data,
            this.authService.getUser().token, 
            this.saveLoadSuccess.bind(this), 
            this.saveLoadError.bind(this));
    }
  
    save() {
        
        this.saving = true;
        this.api.saveSMTPSettings(
            this.getData(),
            this.authService.getUser().token, 
            this.saveSmtpLoadSuccess.bind(this), 
            this.saveLoadError.bind(this));
        
    }

    getData() {
        let data = {
            "account_id": this.userInfo.id,
            "whitelabel_id": this.userInfo.whitelabel_id,
            "user_name": this.user_name,
            "user_pass": this.user_pass,
            "server_port": this.server_port,
            "server_name": this.server_name,
            "from_name": this.from_name,
            "from_email": this.from_email,
            "whitelabel_id": this.whitelabel_id,
            "reply_to_address": this.reply_to_address,
            "smtp_status" : this.smtp_status
        }
        console.log("smtp get data", data);
        return data;
    }

    enableSetting() {
        console.log("smtp setting check", this.smtp_status);
        // this.smtp_status = !this.smtp_status;
    }

    saveLoadSuccess(data) {

        console.log("smtp data", data);
        this.account_id = data.smtp_settings ? data.smtp_settings.account_id : "" ;
        this.whitelabel_id = data.smtp_settings ? data.smtp_settings.whitelabel_id : "" ;
        this.user_name = data.smtp_settings ? data.smtp_settings.user_name : "" ;
        this.user_pass = data.smtp_settings ? data.smtp_settings.user_pass : "" ;
        this.server_port = data.smtp_settings ? data.smtp_settings.server_port : "" ;
        this.server_name = data.smtp_settings ? data.smtp_settings.server_name : "" ;
        this.from_name = data.smtp_settings ? data.smtp_settings.from_name : "" ;
        this.from_email = data.smtp_settings ? data.smtp_settings.from_email : "" ;
        this.reply_to_address = data.smtp_settings ? data.smtp_settings.reply_to_address : "" ;
        this.smtp_status = data.smtp_settings && data.smtp_settings.smtp_status ? true : false ;

        console.log("smtp set data", this.user_name,this.smtp_status);

        // this.userMessageService.setUserMessage("user", "Saved!");

        // this.loading = false;
        // this.parameters = data;
       
        // if(this.saving)
        //     this.userMessageService.setUserMessage("user", "Saved!");
        // this.saving = false;
    }

    saveSmtpLoadSuccess(data) {

        console.log("smtp data", data);
        this.account_id = data.smtp_settings ? data.smtp_settings.account_id : "" ;
        this.whitelabel_id = data.smtp_settings ? data.smtp_settings.whitelabel_id : "" ;
        this.user_name = data.smtp_settings ? data.smtp_settings.user_name : "" ;
        this.user_pass = data.smtp_settings ? data.smtp_settings.user_pass : "" ;
        this.server_port = data.smtp_settings ? data.smtp_settings.server_port : "" ;
        this.server_name = data.smtp_settings ? data.smtp_settings.server_name : "" ;
        this.from_name = data.smtp_settings ? data.smtp_settings.from_name : "" ;
        this.from_email = data.smtp_settings ? data.smtp_settings.from_email : "" ;
        this.reply_to_address = data.smtp_settings ? data.smtp_settings.reply_to_address : "" ;
        this.smtp_status = data.smtp_settings && data.smtp_settings.smtp_status ? true : false ;

        console.log("smtp set data", this.user_name,this.smtp_status);

        this.userMessageService.setUserMessage("user", "Saved!");

    }

    saveLoadError(msg) {
        this.userMessageService.setUserError("user", msg);
        this.loading = false;
        
    }

    itemChanged(item) {
        item.changed = true;
    }

    testSetting() {

        this.api.testSMTPSettings(
            this.getData(),
            this.authService.getUser().token, (data) => {
            this.userMessageService.setUserMessage("user", data.message);

            }, 
            // this.saveSmtpLoadSuccess.bind(this), 
            this.saveLoadError.bind(this));

    }

    
    
    
}
